import React, { useState } from "react";
import { Link } from "@material-ui/core";
import "./Navbar.css";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import Button from "@material-ui/core/Button";
import logo from "./LogoNav.png";
import Fab from "@material-ui/core/Fab";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";

import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import { useMediaQuery } from "@material-ui/core";

export const Navbar = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 9999,
      behavior: "smooth",
    });
  };

  const mobile = useMediaQuery("(max-width:768px)");

  const [on, setOn] = useState(false);

  const drawerHandler = () => {
    setOn(!on);
  };

  return (
    <div className={!mobile ? "NavbarContainer" : "NavbarContainerMob"}>
      <Link className={!mobile ? "logo" : "logoMob"} href="/">
        <img className="imglogo" src={logo} alt="logo" />
      </Link>

      <div className={!mobile ? "options" : "optionsMob"}>
        <div className={!mobile ? "info" : "infoMob"}>
          <div className={!mobile ? "mail" : "mailMob"}>
            <a
              href="mailto:info@blancoseguro.com"
              target="_blank"
              rel="noreferrer"
              className={!mobile ? "txt" : "NavTxtMob"}
            >
              <MailOutlineIcon
                className={mobile ? "iconOff" : ""}
              ></MailOutlineIcon>
              info@blancoseguro.com
            </a>
          </div>
          <div className={!mobile ? "wsp" : "wspMob"}>
            <a
              href="https://wa.me/50242890334 "
              target="_blank"
              rel="noreferrer"
              className={!mobile ? "txt" : "NavTxtMob"}
            >
              <WhatsAppIcon className={mobile ? "iconOff" : ""}></WhatsAppIcon>
              +502 42890334
            </a>
          </div>
          <div className={mobile ? "iconOff" : "face"}>
            <Link
              className="txt"
              href="https://www.facebook.com/BlancoSeguroApp/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FacebookIcon className={mobile ? "iconOff" : ""}></FacebookIcon>
            </Link>
          </div>
          <div className={mobile ? "iconOff" : "insta"}>
            <Link
              href="https://www.instagram.com/blancoseguro/"
              rel="noopener noreferrer"
              target="_blank"
              className="txt"
            >
              <InstagramIcon
                className={mobile ? "iconOff" : ""}
              ></InstagramIcon>
            </Link>
          </div>
        </div>
        {!mobile ? (
          <div className={!mobile ? "menu" : "menuMob"}>
            <Link href="nosotros" className="links">
              acerca de
            </Link>
            <Link href="faq" className="links">
              Preguntas Frecuentes
            </Link>
            <Link href="contacto" className="links">
              contacto
            </Link>
            <Link href="conduce" className="links">
              sé un conductor
            </Link>
            <Button
              disableRipple
              variant="contained"
              color="default"
              className="viaje"
              href="/viaja"
            >
              <p className="viajeTxt"> HAZ UN VIAJE</p>
            </Button>
          </div>
        ) : (
          <div className="menuMob">
            {" "}
            <button className="menuBtn" onClick={drawerHandler}>
              <MenuRoundedIcon></MenuRoundedIcon>
            </button>
            <div className={mobile && on === true ? "drawer" : "drawerOff"}>
              <Link href="nosotros" className="links">
                acerca de
              </Link>
              <Link href="faq" className="links">
                Preguntas
              </Link>
              <Link href="contacto" className="links">
                contacto
              </Link>
              <Link href="conduce" className="links">
                sé un conductor
              </Link>
              <Button
                disableRipple
                variant="contained"
                color="default"
                className="viaje"
              >
                <p className="viajeTxt"> HAZ UN VIAJE</p>
              </Button>{" "}
            </div>
          </div>
        )}
      </div>
      <div className="fabs">
        <Fab
          disableRipple
          onClick={scrollToTop}
          size="large"
          className="up"
          color="inherit"
          aria-label="up"
        >
          <ArrowDownwardRoundedIcon
            fontSize="large"
            style={{ color: "#FFFFFF" }}
          />
        </Fab>
      </div>
    </div>
  );
};
